const TIMEOUT_MS = 6 * 60 * 1000;

export const STOCK_IPG_LOADING_KEY = 'gxo_stock_ipg_loading';
export const REPORTS_LOADING_KEY = 'gxo_reports_loading';

export function getRemainingMs(key: string): number {
  try {
    const raw = localStorage.getItem(key);

    if (!raw) {
      return 0;
    }

    const { timestamp } = JSON.parse(raw) as { timestamp: number };
    const remaining = TIMEOUT_MS - (Date.now() - timestamp);

    if (remaining <= 0) {
      localStorage.removeItem(key);

      return 0;
    }

    return remaining;
  } catch {
    return 0;
  }
}

export function isPersistentlyLoading(key: string): boolean {
  return getRemainingMs(key) > 0;
}

export function setPersistentLoading(key: string): void {
  try {
    localStorage.setItem(key, JSON.stringify({ timestamp: Date.now() }));
  } catch {
    // localStorage may be unavailable (private browsing, storage quota exceeded)
  }
}

export function clearPersistentLoading(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
